import { useState } from "react";

const useChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Hello and welcome to Reecocefe! My name is Tara, and I'm here to assist you. 😊",
    },
    {
      from: "bot",
      text: "How can I assist you today? Please select one of the following options:",
    },
  ]);
  const [input, setInput] = useState("");
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [currentOption, setCurrentOption] = useState(null);
  const [emailRequest, setEmailRequest] = useState(false);

  const toggleChat = () => setIsOpen(!isOpen);

  const addMessage = (from, text) => {
    setMessages((prevMessages) => [...prevMessages, { from, text }]);
  };

  const handleSend = () => {
    if (input.trim() !== "" && !isInputDisabled) {
      addMessage("user", input);
      setInput("");
    }
  };

  const handleOptionSelect = (option) => {
    if (option === "Services") {
      addMessage("bot", "We can drop you an email at?");
      setEmailRequest(true);
      setIsInputDisabled(false);
    } else if (option === "Partnership Assistance") {
      addMessage(
        "bot",
        "We're delighted to explore partnership opportunities with you. Please select the type of partnership you are interested in:"
      );
      setIsInputDisabled(true);
    } else if (option === "Helpdesk") {
      addMessage("bot", "How can I assist you with Helpdesk?");
    }
    setCurrentOption(option);
  };

  const handlePartnershipSelection = (option) => {
    addMessage("user", option);
    setIsInputDisabled(false);
  };

  const handleSkip = () => {
    setCurrentOption(null);
    addMessage(
      "bot",
      "How can I assist you today? Please select one of the following options:"
    );
  };

  return {
    isOpen,
    toggleChat,
    messages,
    input,
    setInput,
    isInputDisabled,
    emailRequest,
    currentOption,
    handleSend,
    handleOptionSelect,
    handlePartnershipSelection,
    handleSkip,
  };
};

export default useChatBot;
